/* ICE Diamonds — tennis bracelet buy box behaviour.
   Matches option selections to a real Shopify variant, updates price and
   availability, and adds an optional second product in the same request. */

(function () {
  'use strict';

  function money(cents) {
    var n = (cents / 100);
    var s = n % 1 === 0 ? n.toFixed(0) : n.toFixed(2);
    return '\u20aa' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function init(root) {
    if (!root || root.dataset.ictlBound) return;
    root.dataset.ictlBound = '1';

    var raw = root.querySelector('[data-ictl-variants]');
    if (!raw) return;

    var variants;
    try { variants = JSON.parse(raw.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var form     = root.querySelector('#ictl-buy-form');
    var idField  = root.querySelector('[data-ictl-id]');
    var priceEl  = root.querySelector('[data-ictl-price]');
    var compEl   = root.querySelector('[data-ictl-compare]');
    var saveEl   = root.querySelector('[data-ictl-save]');
    var instalEl = root.querySelector('[data-ictl-instal]');
    var submit   = root.querySelector('[data-ictl-submit]');
    var qtyInput = root.querySelector('[data-ictl-qtyval]');

    // current selection, one entry per option position
    var chosen = [];
    root.querySelectorAll('[data-ictl-opt]').forEach(function (group) {
      var i = parseInt(group.getAttribute('data-ictl-opt'), 10);
      var on = group.querySelector('[aria-checked="true"]');
      chosen[i] = on ? on.getAttribute('data-ictl-val') : null;
    });

    function match() {
      return variants.filter(function (v) {
        return chosen.every(function (val, i) {
          return val === null || v.options[i] === val;
        });
      })[0] || null;
    }

    // grey out combinations that do not exist or are sold out
    function refreshAvailability() {
      root.querySelectorAll('[data-ictl-opt]').forEach(function (group) {
        var i = parseInt(group.getAttribute('data-ictl-opt'), 10);
        group.querySelectorAll('[data-ictl-val]').forEach(function (btn) {
          var probe = chosen.slice();
          probe[i] = btn.getAttribute('data-ictl-val');
          var ok = variants.some(function (v) {
            return v.available && probe.every(function (val, k) {
              return val === null || v.options[k] === val;
            });
          });
          if (btn.classList.contains('ictl-buy__pill')) btn.disabled = !ok;
          btn.style.opacity = ok ? '' : '.35';
        });
      });
    }

    function render() {
      var v = match();
      refreshAvailability();

      if (!v) {
        if (submit) { submit.disabled = true; submit.textContent = '\u05d0\u05d6\u05dc \u05de\u05d4\u05de\u05dc\u05d0\u05d9'; }
        return;
      }

      if (idField) idField.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);

      var hasCompare = v.compare_at_price && v.compare_at_price > v.price;
      if (compEl) compEl.textContent = hasCompare ? money(v.compare_at_price) : '';
      if (saveEl) {
        saveEl.textContent = hasCompare
          ? '\u05d7\u05e1\u05db\u05ea ' + money(v.compare_at_price - v.price)
          : '';
        saveEl.style.display = hasCompare ? '' : 'none';
      }
      if (instalEl) {
        instalEl.textContent = '\u05d0\u05d5 \u05d15 \u05ea\u05e9\u05dc\u05d5\u05de\u05d9\u05dd \u05e9\u05dc '
          + money(Math.round(v.price / 5))
          + ' \u05dc\u05dc\u05d0 \u05e8\u05d9\u05d1\u05d9\u05ea';
      }

      if (submit) {
        submit.disabled = !v.available;
        submit.textContent = v.available
          ? (submit.dataset.label || submit.textContent)
          : '\u05d0\u05d6\u05dc \u05de\u05d4\u05de\u05dc\u05d0\u05d9';
      }

      // keep the URL shareable, like Shopify's native picker
      if (window.history && history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u);
      }
    }

    if (submit) submit.dataset.label = submit.textContent.trim();

    // option buttons
    root.querySelectorAll('[data-ictl-val]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var i = parseInt(btn.getAttribute('data-ictl-i'), 10);
        var group = root.querySelector('[data-ictl-opt="' + i + '"]');
        if (!group) return;

        group.querySelectorAll('[data-ictl-val]').forEach(function (b) {
          b.setAttribute('aria-checked', 'false');
        });
        btn.setAttribute('aria-checked', 'true');
        chosen[i] = btn.getAttribute('data-ictl-val');

        var lbl = root.querySelector('[data-ictl-chosen="' + i + '"]');
        if (lbl) lbl.textContent = chosen[i];

        render();
      });
    });

    // quantity
    root.querySelectorAll('[data-ictl-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = parseInt(b.getAttribute('data-ictl-qty'), 10);
        var cur = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, cur + step);
      });
    });

    // submit — add the bracelet, plus the add-on when ticked
    if (form) {
      form.addEventListener('submit', function (e) {
        var addon = root.querySelector('[data-ictl-addon]');
        if (!addon || !addon.checked) return;   // let the native post through

        e.preventDefault();
        if (submit) { submit.disabled = true; }

        var items = [
          { id: Number(idField.value), quantity: parseInt(qtyInput.value, 10) || 1 },
          { id: Number(addon.value), quantity: 1 }
        ];

        fetch(window.Shopify && window.Shopify.routes
              ? window.Shopify.routes.root + 'cart/add.js'
              : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () {
          if (submit) submit.disabled = false;
          form.submit();                        // fall back to the plain post
        });
      });
    }

    render();
  }

  function boot() {
    document.querySelectorAll('[data-ictl-buy]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
